import { render, staticRenderFns } from "./TermometriaProdutosImportacao.vue?vue&type=template&id=7675c216&scoped=true&"
import script from "./TermometriaProdutosImportacao.vue?vue&type=script&lang=js&"
export * from "./TermometriaProdutosImportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7675c216",
  null
  
)

export default component.exports